import { useState, useContext } from "react";
import { CartContext } from "../context/CartContext";
import emailjs from "emailjs-com";
import "./Checkout.css";

function Checkout() {
  const { cart } = useContext(CartContext);

  const [form, setForm] = useState({
    firstName: "",
    lastName: "",
    email: "",
    address: "",
    paymentMethod: "Cash on Delivery",
  });

  const total = cart.reduce((sum, item) => sum + item.price * item.qty, 0);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const orderNumber = Date.now().toString().slice(-6);

    // Build orders array for EmailJS template loop
    const ordersArray = cart.map((item) => ({
      product_name: item.name,
      units: item.qty,
      price: item.price * item.qty,
    }));

    emailjs
      .send(
        "service_xhtcsx3", // Service ID
        "template_m2eirkt", // Template ID
        {
          order_id: orderNumber,
          orders: ordersArray,
          total: `L${total}`,
          firstName: form.firstName,
          lastName: form.lastName,
          email: form.email,
          address: form.address,
          paymentMethod: form.paymentMethod,
        },
        "jU5P_1RatrK_Zn_eW" // Public Key
      )
      .then(() => {
        alert("Porosia juaj u krye me sukses! Kontrolloni email-in 📩");
      })
      .catch((err) => {
        console.error("EmailJS Error:", err);
        alert("Na vjen keq, porosia nuk u dërgua.");
      });
  };

  return (
    <div className="checkout-page">
      <h2 className="checkout-title">Checkout</h2>

      <div className="checkout-grid">
        {/* Order Summary */}
        <div className="checkout-summary">
          <h3 className="section-title">Porosia Juaj</h3>
          <ul>
            {cart.map((item, i) => (
              <li key={i}>
                <span>{item.name}</span>
                <span>
                  {item.qty} × L{item.price} ={" "}
                  <strong>L{item.price * item.qty}</strong>
                </span>
              </li>
            ))}
          </ul>
          <h3 className="checkout-total">Totali: L{total}</h3>
        </div>

        {/* Checkout Form */}
        <form onSubmit={handleSubmit} className="checkout-form">
          <h3 className="section-title">Të dhënat e dorëzimit</h3>

          <input
            name="firstName"
            placeholder="Emri"
            onChange={handleChange}
            required
          />
          <input
            name="lastName"
            placeholder="Mbiemri"
            onChange={handleChange}
            required
          />
          <input
            type="email"
            name="email"
            placeholder="Email"
            onChange={handleChange}
            required
          />
          <textarea
            name="address"
            placeholder="Adresa"
            onChange={handleChange}
            required
          />
          <select name="paymentMethod" onChange={handleChange}>
            <option>Cash on Delivery</option>
            <option>Card Payment</option>
          </select>

          <button type="submit" className="checkout-btn">
            Përfundo Porosinë
          </button>
        </form>
      </div>
    </div>
  );
}

export default Checkout;
